module.exports = __webpack_public_path__ + "static/media/mastercard.82d01883.svg";